import PieTooltip from './PieTooltip';

export default PieTooltip;
